<template>
    <div class="modal fade" :id="modalId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog  modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ modalTitle }}</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div v-if="excList.length > 0" class="row">
                        <div class="table-responsive">
                            <table class="main-table table table-bordered">
                                <thead>
                                    <tr>
                                        <th>تاريخ التقديم</th>
                                        <th>نوع الطلب</th>
                                        <th>ملاحظة المتقدم</th>
                                        <th>الإجراء</th>
                                        <th>تاريخ الإجراء</th>
                                        <th>عرض</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(excApp, index) in excList" :key="index" class="bg-blink" :title="excApp?.newExpDate">
                                        <td>{{ excApp.applyDate }}</td>
                                        <td>{{ typeText[excApp.excType] }}</td>
                                        <td :title="excApp.appNote" class="text-compress">{{ excApp.appNote }}</td>
                                        <td :class="'text-' + extStatusClass[excApp.status] ">{{ extStatusText[excApp.status]  }}</td>
                                        <td>{{ excApp.actionDate }}</td>
                                        <td data-bs-dismiss="modal" >
                                            <router-link  class="btn btn-info" :to="'/admin/applicant/extrequest/' + excApp.id + '/' + excApp.excType">عرض التفاصيل</router-link>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <hr />
                        </div>
                    </div>
                    <div v-else class="text-center">
                        <h3>
                            <p class="text-muted">لا توجد نتائج للعرض .</p>
                        </h3>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t("close") }}</button>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

export default {
    name: "ExceptionListModal",
    /** */
    data() {
        return {
            extStatusText: [
                'تم الرفض',
                'في انتظار الإجراء',
                'تمت الموفقة',
            ],
            extStatusClass: [
                'danger',
                'secondary',
                'success',
            ],
            typeText: [
                '',
                'طلب تمديد',
                'محضر استدلال',
                'إسقاط'
            ]
        }
    },
    /** */
    props: {
        modalId: {
            default: "extension-list",
            type: String
        },
        modalTitle: {
            default: "طلبات التمديد",
            type: String
        },
        excList:  {
            default: [],
            type: Array
        },
        dismissable: {
            default: "modal",
            type: String
        },
        exc: null // 1=> extend , 2=> drop
    },
}
</script>
<style>
    .text-compress{
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>